import React from 'react';
import styles from './Size.module.scss';

const Size = () => (
  <div className={styles.productSize}>
    <div className={styles.sizeText}>Size</div>
    <div className={styles.sizes}>
      <div>XS</div>
      <div>S</div>
      <div className={styles.disable}>L</div>
      <div>M</div>
      <div className={styles.disable}>XL</div>
    </div>
  </div>
);

export default Size;
